// // src/lib/api.js
// // Usa Vite (VITE_API) OU CRA (REACT_APP_API / REACT_APP_API_BASE_URL)
// const API_BASE =
//   (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_API) ||
//   process.env.REACT_APP_API ||
//   process.env.REACT_APP_API_BASE_URL ||
//   "http://localhost:5000";

// export async function apiGet(path, opts = {}) {
//   const r = await fetch(`${API_BASE}${path}`, {
//     credentials: opts.credentials ?? "include",
//     headers: opts.headers || {},
//     method: "GET",
//   });
//   if (!r.ok) {
//     const txt = await r.text().catch(() => "");
//     throw new Error(`GET ${path} -> ${r.status} ${txt}`);
//   }
//   return r.json();
// }

// export async function apiPost(path, body, opts = {}) {
//   const r = await fetch(`${API_BASE}${path}`, {
//     method: "POST",
//     credentials: opts.credentials ?? "include",
//     headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
//     body: JSON.stringify(body || {}),
//   });
//   if (!r.ok) {
//     const txt = await r.text().catch(() => "");
//     throw new Error(`POST ${path} -> ${r.status} ${txt}`);
//   }
//   return r.json();
// }

// // (opcional) exportar a base para debug
// export const API_BASE_URL = API_BASE;



// Usa Vite (VITE_API) OU CRA (REACT_APP_API / REACT_APP_API_BASE_URL)
export const API_BASE =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_API) ||
  process.env.REACT_APP_API ||
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:5000";

export async function apiGet(path) {
  const r = await fetch(`${API_BASE}${path}`, { credentials: "include" });
  if (!r.ok) {
    const txt = await r.text().catch(() => "");
    throw new Error(`GET ${path} -> ${r.status} ${txt}`);
  }
  return r.json();
}

export async function apiPost(path, body) {
  const r = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
  if (!r.ok) {
    const txt = await r.text().catch(() => "");
    throw new Error(`POST ${path} -> ${r.status} ${txt}`);
  }
  return r.json();
}
